module.exports = __webpack_public_path__ + "img/testimonials.141b49dc.jpg";